<template>
  <p class="join">Join our mailing list
    <v-dialog v-model="subscribe">
      <template v-slot:activator="{on}">
        <a href="/contact"
          v-on="on"
          @click.prevent="subscribe = true"
        >here</a>
      </template>
      <v-card>
        <v-row align="end" justify="end">
          <v-btn icon @click="subscribe = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
        <SubscribeForm :popUp="true"></SubscribeForm>
      </v-card>
    </v-dialog>
    to find out first about future events!
  </p>
</template>

<script>
import {
  VBtn,
  VCard,
  VDialog,
  VIcon,
  VRow,
} from 'vuetify/lib'
import SubscribeForm from '@/components/SubscribeForm'

export default {
  components: {
    SubscribeForm,
    VBtn,
    VCard,
    VDialog,
    VIcon,
    VRow,
  },
  data: () => ({
    subscribe: false,
  }),
}
</script>
